<tec-tile [id]="OPERATION_TYPE.HOME"
	[title]="operation.title"
	[subtitle]="operation.description"
	[formGroup]="group"
	[icon]="operation.icon">

	<!-- TERMS AND CONDITIONS -->
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.TERMS_AND_CONDITIONS' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.TERMS_AND_CONDITIONS_DESCRIPTION' | translate">
		@if (tecalisPolicyCheck) {
			<tec-item title="Tecalis" [tagImage]="{icon: 'icon-shield', status:'default'}"
				[clickeable]="false" collapse>
				<tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate" status="warning"></tec-tag>
				<span [innerHTML]="workflowsHelper.tecalisPolicy"></span>
				@if (checksArray.length > 0) {
					<tec-menu
						[options]="workflowsHelper.policyChecksMenuOpt"
						(valueChange)="tecalisPolicyMenuChange($event)">
						<tec-button-icon
							[icon]="'icon-more'"
							[type]="'default'"
						></tec-button-icon>
					</tec-menu>
				}
			</tec-item>
		}
		<ng-container formArrayName="policy_checks">
			@for (check of checksArray.controls; track check; let i = $index) {
				<tec-item [title]="checksArray.controls[i]?.value?.custom_id" [tagImage]="{icon: 'icon-shield', status:'default'}"
					[clickeable]="false" collapse>
					<tec-tag
						[label]="checksArray.controls[i]?.value?.required ? ('WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate) : ('WORKFLOWS.FORM.OPERATIONS.OPTIONAL' | translate)"
						[status]="checksArray.controls[i]?.value?.required ? 'warning' : 'default'"
					></tec-tag>
					<app-text-locale-preview [textLocale]="checksArray.controls[i]?.value?.html" />
					<tec-menu
						[options]="workflowsHelper.policyChecksMenuOpt"
						(valueChange)="policyCheckMenuChange($event, i)">
						<tec-button-icon
							[icon]="'icon-more'"
							[type]="'default'"
						></tec-button-icon>
					</tec-menu>
				</tec-item>
			}
		</ng-container>
		<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.ADD_POLICY_CHECK' | translate">
			<tec-select
				[options]="policyChecksOptions"
				[formControl]="selectedPolicyCheckControl"
				[placeholder]="'WORKFLOWS.FORM.OPERATIONS.SELECT_POLICY_CHECK' | translate"
				[linkLabel]="'BUTTON.ADD' | translate"
				(linkEvent)="openCreateTermsModal()"
				(valueChange)="addPolicyCheck($event)"
			/>
		</tec-form-group>
	</tec-tile>

	<!-- CONFIGURACIÓN AVANZADA -->
	<app-workflow-form-advanced-collapse [expanded]="id || expandHomeIndicationsForLocaleScroll">
		<div class="item-group">
			<tec-tile styling="transparent"
				[title]="'WORKFLOWS.FORM.OPERATIONS.INDICATIONS' | translate"
				[subtitle]="'WORKFLOWS.FORM.OPERATIONS.DESCRIPTION_EXT' | translate">
				<div id="workflow-locale-anchor-home" class="grid grid-i2 workflow-locale-anchor">
					@for (tab of workflowLocaleTabs; track tab.id) {
						<div [id]="'workflow-locale-home-' + tab.id">
							<tec-form-group [label]="tab.label">
								<tec-input
									[formControl]="getWorkflowLocaleControl('operations', OPERATION_TYPE.HOME, 'description', tab.id)"
									[hasError]="reactiveFormService.hasError(getWorkflowLocaleControl('operations', OPERATION_TYPE.HOME, 'description', tab.id))"
								/>
							</tec-form-group>
						</div>
					}
				</div>
			</tec-tile>
		</div>
	</app-workflow-form-advanced-collapse>
</tec-tile>
